import { cn } from "../../lib/utils";

interface Props {
  tone?: "ok" | "warn" | "danger" | "neutral";
  pulse?: boolean;
  className?: string;
}

const TONE = {
  ok: "bg-success",
  warn: "bg-warning",
  danger: "bg-destructive",
  neutral: "bg-muted-foreground/40",
} as const;

const PULSE = {
  ok: "bg-success",
  warn: "bg-warning",
  danger: "bg-destructive",
  neutral: "bg-muted-foreground/40",
} as const;

export function StatusDot({ tone = "ok", pulse = false, className }: Props) {
  return (
    <span className={cn("relative inline-flex h-2 w-2", className)} aria-hidden>
      {pulse && (
        <span className={cn("absolute inline-flex h-full w-full animate-ping rounded-full opacity-50", PULSE[tone])} />
      )}
      <span className={cn("relative inline-flex h-2 w-2 rounded-full", TONE[tone])} />
    </span>
  );
}
